// extracted by mini-css-extract-plugin
export default {"data-hook-wrapper":"_3v_5K","dataHookWrapper":"_3v_5K","core-badge":"_FcK0","coreBadge":"_FcK0"};